<template>
  <div>
    <div class="router_box" v-if="showInput">
      <b>路线</b>
      <div style="margin: 0.2rem 0rem;width: 9.44rem;">
        <p>
          <el-radio v-model="spotData.planType" :label="1">有相对准确的日期</el-radio>
          <el-radio v-model="spotData.planType" :label="2">有大致日期范围</el-radio>
        </p>
        <div class="vague">
          <p>
            <span v-show="spotData.planType==1">
              <el-date-picker style="width: 2.32rem" class="dateBox" value-format="yyyy-MM-dd" size="mini" v-model="spotData.inquiryPlan.dateRange" 
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </span>
            <span v-show="spotData.planType==2">
              <span>
                <el-select v-model="spotData.inquiryPlan.useDate" placeholder="请选择" style='    width: 1.3rem;' size="mini">
                  <el-option v-for="i in yearOption" :key="i" :label="i+'年'" :value="i"></el-option>
                </el-select>
              </span>
              <span>
                <el-select v-model="spotData.inquiryPlan.useMonth" placeholder="请选择" style='    width: 1.3rem;' size="mini">
                  <el-option v-for="i in 12" :key="i" :label="i+'月'" :value="i">
                  </el-option>
                </el-select>
              </span>
              <b>用&nbsp;</b>
              <span>
                <el-input v-model="spotData.inquiryPlan.useDay" placeholder="请填写" style="width:80px;" size="mini"
                  @input="spotData.inquiryPlan.useDay=spotData.inquiryPlan.useDay.replace(/[^\d]/g,'')"></el-input>
              </span>
              <b>天&nbsp;</b>
            </span>
            <span>
              <el-input v-model="spotData.inquiryPlan.remark" placeholder="请输入内容" size="mini" style="width:5rem"></el-input>
            </span>
          </p>
          <p>
            <span>开始城市</span>
            <span>
              <city-autocomplete :obj="spotData.inquiryPlan.cityObj" :width="'width: 1.5rem;'"></city-autocomplete>
            </span>
            <span>结束城市</span>
            <span>
              <city-autocomplete :obj="spotData.inquiryPlan.endCityObj" :width="'width: 1.5rem;'"></city-autocomplete>
            </span>
            <span>其他途径城市</span>
            <span>
              <city-autocomplete :obj="spotData.inquiryPlan.otherCityObj" :width="'width: 1.5rem;'" :action="false" 
                @handleSelect="handleSelect($event,spotData.inquiryPlan)"></city-autocomplete>
            </span>
            <span class="tag_box">
              <el-tag v-for="(tag,ind) in spotData.inquiryPlan.channelCities" :key="ind" closable type="warning"
                @close="delUseDate(spotData.inquiryPlan.channelCities,ind)"
                style="margin-right: 0.05rem;height: 0.4rem;line-height: 0.4rem;">
                {{tag.cityName}}
              </el-tag>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div v-else></div>  
  </div>
</template>

<script>
import CityAutocomplete from '../common/cityAutocomplete.vue'
export default {
  props:{
    spotData:{
      type:Object,
      default: ()=>{return{}}
    },
    showInput:{
      type:Boolean,
      default:true
    },
    yearOption:{
      type:Array,
      default: ()=>{return[]}
    }
  },
  methods:{
    handleSelect(item,data){
      data.channelCities.push({
        cityId:item.cityId,
        cityName:item.cityNameCn
      })
    },
    delUseDate(arr,index){
      arr.splice(index);
    },
  },
  components:{CityAutocomplete,}
}
</script>

<style lang="scss" scoped>
.router_box{
  background: #f7f7f7;
  border-radius: 5px;
  margin: 0.16rem 0;
  padding: 0.05rem 0.3rem 0.05rem 0.05rem;
  font-size: 0.12rem;
  display: flex;
  >b{
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: #e17148;
    color: #fff;
    font-size: 0.18rem;
    text-align: center;
    line-height: 0.5rem;
    font-weight: normal;
    margin-right: 0.3rem;
  }
  /deep/ .el-input__inner{
    padding-right: 0.1rem !important;
  }
  /deep/ .el-input__prefix{
    left: 4px;
  }
  .accurate{
    .li{
      display: flex;
      margin-top: 0.1rem;
      justify-content: space-between;
      .b1{
        height: 0.4rem;
        line-height: 0.3rem;
      }
      .b2{
        font-size: 0.25rem;
      }
      .lidiv{
        display: flex;
        width: 8.3rem;
        flex-wrap: wrap;
      }
    }
  }
  .vague{
    >p{
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      >span{
        margin-right: 0.05rem;
      }
    }
  }
}
</style>